import React from "react";
import CodeEmbed from "../../codeEmbed";

function StoryblokCodeEmbed({ code }) {
  return <CodeEmbed code={code} />;
}

export default StoryblokCodeEmbed;
